import React from "react";
import logo from "../../assets/WALLS_logo-white.png";
import ingta from "../../assets/instagram-with-wordmark-seeklogo.svg";
import LazyOnScroll from "../../ui/LazyOnScroll";

export default function Footer() {
  return (
    <footer className="w-full border-t bg-[#f9faf1] text-[#484331] px-4">
      <LazyOnScroll>
        <div className="container max-w-screen-2xl mx-auto px-4 md:px-6 lg:px-12 xl:px-20 py-12 md:py-16">
          <div className="grid gap-y-16 gap-x-12 sm:grid-cols-2 lg:grid-cols-4 text-left">
            {/* Logo + Instagram */}
            <div className="sm:col-span-2 lg:col-span-1 space-y-6 text-center sm:text-left">
              <div className="flex justify-center sm:justify-start">
                <img
                  src={logo}
                  alt="WALLS Architecture"
                  className="h-24 w-auto"
                />
              </div>
              <div className="flex justify-center">
                <a
                  href="https://www.instagram.com/wa.lls2020?igsh=MW55b3RjMmQwMXE0Ng=="
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block hover:opacity-80 transition-opacity p-2"
                >
                  <img src={ingta} alt="Follow us on Instagram" className="h-12" />
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div className="space-y-6">
              <h3 className="text-lg font-bold text-[#484331] border-b border-[#484331]/20 pb-2">Quick Links</h3>
              <nav className="flex flex-col gap-3">
                <a href="/" className="text-base font-medium text-muted-foreground hover:text-[#484331] transition-colors">
                  Home
                </a>
                <a href="/about" className="text-base font-medium text-muted-foreground hover:text-[#484331] transition-colors">
                  About
                </a>
                <a href="/portfolio" className="text-base font-medium text-muted-foreground hover:text-[#484331] transition-colors">
                  Portfolio
                </a>
                <a href="/contact" className="text-base font-medium text-muted-foreground hover:text-[#484331] transition-colors">
                  Contact
                </a>
              </nav>
            </div>

            {/* Services */}
            <div className="space-y-6">
              <h3 className="text-lg font-bold text-[#484331] border-b border-[#484331]/20 pb-2">Services</h3>
              <nav className="flex flex-col gap-3">
                <span className="text-base font-medium text-muted-foreground cursor-default">
                  Residential Design
                </span>
                <span className="text-base font-medium text-muted-foreground cursor-default">
                  Commercial Architecture
                </span>
                <span className="text-base font-medium text-muted-foreground cursor-default">
                  Interior Design
                </span>
                <span className="text-base font-medium text-muted-foreground cursor-default">
                  Urban Planning
                </span>
              </nav>
            </div>

            {/* Contact */}
            <div className="space-y-6">
              <h3 className="text-lg font-bold text-[#484331] border-b border-[#484331]/20 pb-2">Contact Us</h3>
              <div className="space-y-4">
                <div className="space-y-1">
                  <p className="text-sm font-semibold text-[#484331]">Address</p>
                  <address className="text-base font-medium text-muted-foreground not-italic leading-relaxed">
                    R-14/91, Raj nagar,<br/>
                    Sector 14,<br/>
                    Ghaziabad, Uttar Pradesh
                  </address>
                </div>
                <div className="space-y-2">
                  <p className="text-sm font-semibold text-[#484331]">Phone</p>
                  <div className="space-y-1">
                    <a href="tel:8882611340" className="block text-base font-medium text-muted-foreground hover:text-[#484331] transition-colors">
                      +91 88826 11340
                    </a>
                    <a href="tel:8077914562" className="block text-base font-medium text-muted-foreground hover:text-[#484331] transition-colors">
                      +91 80779 14562
                    </a>
                  </div>
                </div>
                <div className="space-y-1">
                  <p className="text-sm font-semibold text-[#484331]">Email</p>
                  <a href="mailto:wallsarchitects@gmail.com" className="text-base font-medium text-muted-foreground hover:text-[#484331] transition-colors">
                    wallsarchitects@gmail.com
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="mt-12 border-t pt-6 flex flex-col sm:flex-row justify-center items-center text-center gap-4">
            <p className="text-sm font-medium text-muted-foreground">
              &copy; {new Date().getFullYear()} WALLS. All rights reserved.
            </p>
          </div>
        </div>
      </LazyOnScroll>
    </footer>
  );
}
